import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { MessageService } from './shared/messages/message.service';
import { LoggerService } from './shared/services/logger.service';
import { ErrorMessageModel } from './shared/models/message-model.model';
import { ErrorSeverityEnum } from './shared/models/error-severity-enum.model';
import { EndpointLocationProviderService } from './shared/services/endpoint-location-provider.service';
import { environment } from '../environments/environment';
import { PermissionService } from './shared/services/permission.service';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError =
  <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandler {
  // Mensagens para envio
  errorMessage: ErrorMessageModel;
  permissions: string[] = [];
  private env = environment;

  constructor(
    private http: HttpClient,
    private messenger: MessageService,
    private loggerService: LoggerService,
    private endpointLocationService: EndpointLocationProviderService,
    private permissionService: PermissionService
  ) { 

    this.permissionService.permissions$.subscribe((newPermissions) => {
      this.permissions = newPermissions;
    });

  }

  /** Create curried handleError function that already knows the service name */
  createHandleError = (serviceName = '') => <T>
    (operation = 'operation', result = {} as T) => this.handleError(serviceName, operation, result)

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {

    return (error: HttpErrorResponse): Observable<T> => {
      const started = Date.now();
      // Salva o erro no GrayLog


    
      if (!this.permissions["identityName"]) {
      this.http
        .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_AUTENTICACAO_SESSION)}/GetIdentityName`)
        .subscribe(userName => {
          this.loggerService.logger(this.buildGrayLogObject(error, serviceName, operation, userName.toString())).subscribe();
        }); 
       } 

      // Monta o objeto ErrorMessage para adicionar na lista de tratamento do service
      this.errorMessage = {
        title: `Erro no Serviço ${serviceName}!`,
        text: `${operation} com falha: "${JSON.stringify(error)}".`,
        type: 'error',
        toast: false,
        errorStack: `Tempo em execução: "${Date.now() - started}"`,
        errorSeverity: ErrorSeverityEnum.High,
        isServerSide: false,
        isThreatedError: false,
        alreadySended: false,
        showToUser: false
      };
      // Adiciona o erro na lista
      this.messenger.addErrorToVault(this.errorMessage);
      // Executa o tratamento
      this.messenger.triggerMessages();
      // Let the app keep running by returning a safe result.
      // throw new Error(error.message);
      return of();

    };

  }

  /**
   * Método responsável por criar o objeto para enviar a API do GrayLog.
   * @variation toDeprecate Método para ser depreciado após incluir o modelo correto GELF na API do GrayLog.
   * @param error Objeto ErrorResponse com as informações de erro do retorno HTTP.
   * @param serviceName Nome do serviço e função do próprio onde executou a chamada HTTP.
   * @param operation Operação HTTP executada.
   */
  private buildGrayLogObject(error: any, serviceName: string, operation: string, userName: string) {
    return {
      version: navigator.appVersion,
      host: navigator.userAgent,
      short_message: `Executando: ${serviceName}, operação: ${operation}`,
      full_message: JSON.stringify(error),
      timestamp: Date.now(),
      level: 'ClientSide',
      facility: 'GELF',
      line: '',
      userName: userName
    };
  }
}
